// extracted by mini-css-extract-plugin
export var container = "ImageWithText-module--container--pn7sL";
export var inner = "ImageWithText-module--inner--+tk7m";
export var imageWithText = "ImageWithText-module--imageWithText--cGhm4";
export var left = "ImageWithText-module--left--AnMYx";
export var right = "ImageWithText-module--right--tLboz";
export var text = "ImageWithText-module--text--mkCx6";